import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setGlobalNavigate } from "./utils/navigation";
import SpeakerPage from "./pages/SpeakerPage.jsx";
import AttendeePage from "./pages/AttendeePage.jsx";
import "./App.css";
import EndPresentation from "./pages/EndPresentation.jsx";
import Login from "./pages/Login.jsx";
import HomePage from "./pages/HomePage.jsx";
import Presentations from "./pages/Presentations.jsx";
import CreatePresentation from "./pages/CreatePresentation.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import PreviewPresentation from "./components/Presentations/PreviewPresentation.jsx";
import EditPresentation from "./components/Presentations/EditPresentation.jsx";
import AnimationEditor from "./components/AnimateTab/AnimationEditor.jsx";
import Admin from "./pages/Admin.jsx";
import ReportPresentation from "./components/Presentations/ReportPresentation.jsx";
import Roles from "./pages/Roles.jsx";
import Brands from "./pages/Brands.jsx";
import AssignPresentation from "./components/Presentations/AssignPresentation.jsx";
import { AnimationProvider } from "./components/AnimateTab/AnimationContext.jsx";
import ForgotPassword from "./pages/ForgotPassword.jsx";
import ResetPassword from "./pages/ResetPassword.jsx";

function NavigationSetter() {
  const navigate = useNavigate();

  useEffect(() => {
    setGlobalNavigate(navigate);
  }, [navigate]);

  return null;
}

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AnimationProvider>
        <NavigationSetter />
        <ToastContainer />

        <div className="App">
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              }
            />

            <Route path="/:uuid" element={<SpeakerPage />} />
            <Route
              path="/:uuid/sessions/:sessionId"
              element={<SpeakerPage />}
            />
            <Route path="/:uuid/attendee" element={<AttendeePage />} />
            <Route
              path="/:uuid/sessions/:sessionId/attendee"
              element={<AttendeePage />}
            />

            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
              path="/presentations"
              element={
                <ProtectedRoute>
                  <Presentations />
                </ProtectedRoute>
              }
            />

            <Route
              path="/roles"
              element={
                <ProtectedRoute>
                  <Roles />
                </ProtectedRoute>
              }
            />

            <Route
              path="/brands"
              element={
                <ProtectedRoute>
                  <Brands />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />

            <Route
              path="/creating-presentation"
              element={
                <ProtectedRoute requiredPermission="create presentations">
                  <CreatePresentation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/assign-presentation/:uuid"
              element={
                <ProtectedRoute>
                  <AssignPresentation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/preview-presentation/:uuid"
              element={
                <ProtectedRoute>
                  <PreviewPresentation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-presentation/:uuid"
              element={
                <ProtectedRoute>
                  <EditPresentation />
                </ProtectedRoute>
              }
            />

            <Route
              path="/animate-presentation/:uuid"
              element={
                <ProtectedRoute>
                  <AnimationEditor />
                </ProtectedRoute>
              }
            />

            <Route
              path="/report-presentation/:id"
              element={
                <ProtectedRoute>
                  <ReportPresentation />
                </ProtectedRoute>
              }
            />

            <Route path="/end-presentation" element={<EndPresentation />} />
            <Route
              path="/sessions/:sessionId/end"
              element={<EndPresentation />}
            />
          </Routes>
        </div>
      </AnimationProvider>
    </Router>
  );
}

export default App;
